import { CloseIcon } from './icons.jsx'

export default function DisclaimerBanner({ onDismiss }) {
  return (
    <div className="disclaimer-banner">
      <p className="disclaimer-text">
        These resources are not intended as medical advice or to
        <br />
        replace recommendations from your health care
        <br />
        professional. Please consult your healthcare team for
        <br />
        medical advice.
      </p>
      <button
        className="icon-btn disclaimer-close"
        onClick={onDismiss}
        aria-label="Dismiss disclaimer"
      >
        <CloseIcon />
      </button>
    </div>
  )
}
